<template>
  <b-container class="wrap-category-detail">
    <b-row class="box-head">
      <b-col
        cols="12"
        md="8"
        class="box-breadcrumb"
      >
        <b-breadcrumb :items="breadcrumbs" />
      </b-col>
      <b-col
        cols="12"
        md="4"
        class="box-back-btn"
      >
        <button @click.prevent="goBack()">
          Back to News
        </button>
      </b-col>
    </b-row>
    <div
      class="wrap-content"
    >
      <h1>{{ title }}</h1>
      <!-- <div
        v-if="subCate"
        class="box-content"
      >

        <h2>{{ subCate.name }}</h2>
        {{subCate}}
        <div
          v-for="content in subCate.award"
          :key="content.id"
          class="box-context"
        >
        {{content}}
          <div class="box"></div>
          <div class="box-text">
            <h3>{{ content.name }}</h3>
            <hr>
            <span v-html="content.content"></span>
          </div>
        </div>
      </div> -->

      <div
        v-if="subContents"
        class="box-content"
      >
        <div
          v-for="content in subContents"
          :key="content.id"
          class="box-detail"
        >
          <h2>{{ content.name }}</h2>
          <div
            v-for="award in content.award"
            :key="award.id"
          >
            <div class="box"></div>
            <div class="box-text">
              <h3>{{ award.name }}</h3>
              <p v-html="award.content"></p>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="contents"
        class="box-content"
      >
        <div
          v-for="content in contents"
          :key="content.id"
        >
          <div class="box"></div>
          <div class="box-text">
            <h3>{{ content.name }}</h3>
            <p v-html="content.content"></p>
          </div>
        </div>
      </div>
    </div>

  </b-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      breadcrumbs: [
        {
          text: 'Home',
          to: {
            name: 'home'
          }
        },
        {
          text: 'Award',
          to: {
            name: 'awards'
          }
        }
      ],
      title: '',
      contents: [],
      subContents: []
    }
  },

  computed: {
    ...mapState({
      categoriesList: state => state.awards.categoriesList,
      categoriesDetail: state => state.awards.categoriesDetail
    }),

    routeParam () {
      return this.$route.params.id
    }
  },

  methods: {
    checkTitle (data) {
      if (data) {
        data.forEach((item, i) => {
          if (i === 0) {
            this.title = item.name

            const obj = {
              text: item.name
            }

            this.breadcrumbs.push(obj)
          }
        })
      }
    },

    macthContents (data) {
      if (data) {
        this.contents = []
        this.subContents = []

        data.forEach(item => {
          if (item.subcategory) {
            item.subcategory.forEach(sub => {
              this.subContents.push(sub)
              // sub.award.forEach(award => {
              // this.contents.push(award)
              // })
              // this.contents.push(sub.award)
              // this.contents = sub.award
              this.subCate = sub.name
            })
          } else {
            item.award.forEach(award => {
              this.contents.push(award)
            })
            // this.contents.push(item.award)
            // this.contents = item.award
          }
        })
      }
    },

    goBack () {
      this.$router.go(-1)
    }
  },

  created () {
    if (!this.categoriesDetail) {
      this.$store.dispatch('awards/getCateDetail', this.$route.params.id)
    }

    this.checkTitle()
    this.macthContents(this.categoriesDetail)
  },

  watch: {
    categoriesDetail (data) {
      this.checkTitle(data)
      this.macthContents(data)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-category-detail {
  .box-head {
    padding: 22px 0;
    border-bottom: 1px solid #CCC;

    .box-breadcrumb {
      display: flex;
      align-items: center;

      .breadcrumb {
        margin: 0;
        padding: 0;
        background: none;

        li {
          font-size: 1.25rem;

          a {
            color: black;
          }
        }
      }
    }

    .box-back-btn {
      margin-top: 22px;

      @media only screen and (min-width: $break-m) {
        margin-top: 0;
      }

      button {
        width: 100%;
        background-color: #CCC;
        padding: 12px 0;
        font-size: 1.25rem;
      }
    }
  }

  .wrap-content {
    padding: 22px 0 0 0;

    h1 {
      margin: 12px 0 11px 0;
      font-size: 2.5rem;
      color: #6D6E71;
    }

    .box-content {
      margin-bottom: 22px;
      .box-detail {
        padding-bottom: 12px;
      }

      .box {
          float: left;
          margin: 8px 0 0 0;
          width: 15px;
          height: 15px;
          background-color: $active;
        }

        h2 {
          padding: 11px 0;
          font-size: 2.75rem;
          color: $active;
        }

        .box-text {
          margin-left: 22px;
          h3 {
            padding: 0 0;
            font-size: 1.75rem;
            border-bottom: 1px solid #CCC;
          }

          p {
            padding: 11px 0;
            font-size: 1.25rem;
            line-height: 1.2;
          }
        }

      // h2 {
      //   margin-bottom: 12px;
      //   font-size: 2.75rem;
      //   color: $active;
      // }

      // .box-context {
      //   margin-bottom: 22px;

      //   .box {
      //     display: inline-block;
      //     // margin-top: 8px;
      //     width: 15px;
      //     height: 15px;
      //     background-color: $active;
      //   }

      //   .box-text {
      //     display: inline-block;
      //     margin-top: -32px;
      //     margin-left: 22px;

      //     h3 {
      //       font-size: 1.75rem;
      //     }

      //     p {
      //       line-height: 0.8;
      //       font-size: 1.25rem;
      //     }
      //   }
      // }
    }
  }
}
</style>
